import { render } from "./EmailAttachmentLink.vue?vue&type=template&id=f9907464&scoped=true"
import script from "./EmailAttachmentLink.vue?vue&type=script&lang=js"
export * from "./EmailAttachmentLink.vue?vue&type=script&lang=js"

import "./EmailAttachmentLink.vue?vue&type=style&index=0&id=f9907464&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9907464"]])

export default __exports__